module.exports = __webpack_public_path__ + "static/media/google_signin@3x.9967cd2a.png";